
import { defineComponent, computed, ref } from 'vue'
import activeFilter from '@/components/active_filter.components.vue'
import resetActiveFilter from '@/components/reset_active.components.vue'
import cardItem from '@/components/card.components.vue'
import paginatorComponent from '@/components/paginator.components.vue'
import recherchevehicule from "@/services/recherche_page.services"
import * as config from "@/config.json"

export default defineComponent({
  name: 'cardsDisplay',
  inventairePosition: 200,
  components: {
    activeFilter,
    resetActiveFilter,
    cardItem,
    paginatorComponent
  },
    setup: () => {
    const {
      state,
      ucFirst,
      changePage,
      openFilter,
      removeActiveFilter,
      switchCards
    } = recherchevehicule;
    // Chemin du serveur des photos de véhicules
    const serverPhotoPath = config.photoVehiculePath;
    const defaultImg = String(config.defaultImgLocale).replace('%locale%', state.locale);
    // Convertir les infos du véhicule pour le lien HREF valide pour le SEO
    function vehiculeStringify(brand: string, model: string, year: number): string {
      const vehicule = brand.toLowerCase() + '-' + model.toLowerCase() + '-' + year.toString();
      let stringify = vehicule.replace(new RegExp(/\s+/g), '-');
      return stringify;
    }
    function inventairePosition(defaultPosition: number): number {
      return Number(recherchevehicule.inventairePositionTop(true) || defaultPosition);
    }
    function calculFinancement(vehicule:any){
      let returnArray: string[] = [] ;
      const vehicule_has_financing = vehicule['vehicule_financement_disponible_b'];

      if(vehicule_has_financing == false){
        returnArray = ["false","","",""]
      }else{
        let interet = typeof vehicule['vehicule_financement_particulier_pourcentage_d'] !== "undefined" 
                              ? vehicule['vehicule_financement_particulier_pourcentage_d'] 
                              : vehicule['marchand_pourcentage_financement_particulier_d'];
        let duree = typeof vehicule['vehicule_financement_particulier_duree_i'] !== "undefined"
                              ? vehicule['vehicule_financement_particulier_duree_i'] 
                              : vehicule['marchand_duree_financement_particulier_i'];
        const cost = (vehicule['vehicule_prix_d']*(interet/100))/52;
        const tauxEquivalent  = 1 - Math.pow(1 + ((interet / 100) / 52),(-52*(duree/12)));
        const total = cost / tauxEquivalent;
        const returnArray = ["true", interet.toString(), duree.toString(), Math.round(total) ]
        return returnArray;
      }
    }

    return {
      state,
      computed,
      serverPhotoPath,
      defaultImg,
      ucFirst,
      changePage,
      openFilter,
      removeActiveFilter,
      switchCards,
      inventairePosition,
      calculFinancement,
      vehiculeStringify
    }
  },

  methods: {
    positionBtn() {
      (this.state.scrollPosition as any) = window.scrollY;
    }
  },

  mounted() {
    window.addEventListener('scroll', this.positionBtn);
  }
})
